import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios';
import { Url } from '../Url';

const FEditReparto = () => {
    const [total, setTotal] = useState(0)
    const [productos, setProductos] = useState([])
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1')
    const { repartoSelected, setViewOpen, modify, setModify } = useContext(ContextStates)

    useEffect(() => {
        const cargarArray = () => {
            let i = 0;
            let rData = [];
            repartoSelected.productos.forEach(element => {
                rData.push({
                    "index": i,
                    "idproducto": element.idproducto,
                    "codigo": element.codigo,
                    "descripcion": element.descripcion,
                    "cantidadinicial": element.cantidadinicial,
                    "cantidadfinal": element.cantidadfinal,
                    "monto": element.monto,
                    "montoventas": element.montoventas,
                    "eliminado": 0
                }
                )
                i++;
            });
            setProductos(rData)
        }
        cargarArray();
    }, [])

    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof productos !== 'undefined') {
                productos.forEach(element => {
                    t = t + parseInt(element.montoventas)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [productos])

    const handleSetCantidadI = (e, index) => {
        let rData = [...productos]
        rData.forEach(element => {
            if (element.idproducto === index) {
                let auxMonto = element.monto;
                element.cantidadinicial = e
                let aux = parseFloat(element.monto) * (parseFloat(element.cantidadinicial)-parseFloat(element.cantidadfinal));
                element.montoventas = aux;
                //setModificado(true)
                return
            }
        });
        setProductos(rData)
    }

    const handleSetCantidadF = (e, index) => {
        let rData = [...productos]
        rData.forEach(element => {
            if (element.idproducto === index) {
                element.cantidadfinal = e
                let aux = parseFloat(element.monto) * (parseFloat(element.cantidadinicial)-parseFloat(element.cantidadfinal));
                element.montoventas = aux;
                
                //setModificado(true)
                return
            }
        });
        console.log("llega al final ")
        setProductos(rData)
    }

    const setReparto = async () => {
        const auxReparto = JSON.stringify(productos)
        const formData = new FormData()
        formData.append('reparto', auxReparto);
        formData.append('idreparto', repartoSelected.idreparto);
        
        try {
            const results = await axios({
                url: Url + 'api/setReparto.php',
                method: 'POST',
                data: formData,
            })
            let aux = modify + 1;
            setModify(aux)
            setViewOpen(false)
        } catch (e) {
            console.log(e)
        }
    }


    return (
        <div className="w-full py-5 px-2 md:px-20 rounded-2xl">
            <h2 className='text-center text-gray-700 text-xl'>Reparto {repartoSelected.fecha}</h2>
            {repartoSelected.apellido && (
                <div className='w-full mx-auto p-10'>
                    <p className='text-center text-lg'>Repartidor: {repartoSelected.apellido}</p>
                </div>
            )}
            {typeof productos !== 'undefined' && (
                <table className='w-full mx-auto'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white text-center'>
                            <th>Producto</th>
                            <th>Lleva</th>
                            <th>Trae</th>
                            <th>Suma</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            productos.map((item, index) => (
                                <tr key={index} className='border border-gray-300 p-2 text-center'>
                                    <td>{item.descripcion}</td>
                                    <td>
                                        <input type='text' className='w-full px-2 text-right border border-gray-400' value={item.cantidadinicial} onChange={(e) => handleSetCantidadI(e.target.value, item.idproducto)} />
                                    </td>
                                    <td>
                                        <input type='text' className='w-full px-2 text-right border border-gray-400' value={item.cantidadfinal} onChange={(e) => handleSetCantidadF(e.target.value, item.idproducto)} />    
                                    </td>
                                    <td>
                                        {item.montoventas}
                                    </td>
                                </tr>
                            ))
                        }
                        <tr className='border border-gray-300 p-2 text-center'>
                            <th colSpan={3}>Total</th>
                            <th>${total}</th>
                        </tr>
                    </tbody>
                </table>
            )}
            <div className='bg-gray-50 rounded-lg p-5'>
                {typeof medios !== 'undefined' && medios.map((item, index) =>
                    <div key={index} className="radio">
                        <label>
                            <input
                                type="radio"
                                name="medioPago"
                                value={item.id}
                                checked={medioPago === item.id}
                                onChange={() => setMedioPago(item.id)}
                                className='mr-5'
                            />
                            {item.descripcion}
                        </label>
                    </div>
                )}
            </div>
            <div className='w-1/3 mx-auto'>
                <button type='button'
                    className='w-full p-3 bg-red-500 text-white uppercase font-semibold rounded'
                    onClick={() => setReparto()}
                >
                    Modificar Reparto
                </button>
            </div>
        </div>
    )
}

export default FEditReparto